import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsDefectSeverity, PmsDefectSeverity } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsDefectSeverity>
    useData={usePmsDefectSeverity}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
